<div class="mb-4">
  <mwe-basic-card>
    <h6 [translate]="customerDataType() !== 'Businesskunde' ? 'summary.personalData' : 'summary.businessData'"></h6>
    <div class="row w-100">
      <div class="col-12">
        <ul class="list-separated spacing-4" data-test="products-summary-customerData">
          <li data-test="products-summary-customerData-name">
            <p class="text--big mb-0">
              <strong><span translate="summary.customerData"></span></strong><br />
              @if (!!customerDataType() && !isKundeWerden) {
                <span>{{ customerDataType() }} <br /></span>
              }
              @if (customerDataType() === 'Businesskunde') {
                @if (businessData?.companyName) {
                  <span> <span translate="newClient.summary.companyName"></span>: {{ businessData.companyName }} </span>
                }
                @if (businessData?.uidNumber) {
                  <span> <br /><span translate="newClient.summary.uidNumber"></span>: {{ businessData.uidNumber }} </span>
                }
                @if (businessData?.corporateRegisterNumber) {
                  <span>
                    <br /><span translate="newClient.summary.corporateRegisterNumber"></span>:
                    {{ businessData.corporateRegisterNumber }}
                  </span>
                }
              }
              <span data-test="products-summary-customer-name">
                {{ salutation ? salutation + ' ' : '' }}{{ title ? title + ' ' : '' }}{{ firstname }} {{ lastname }}
              </span>
              @if (!customerDataType() || (!!customerDataType() && customerDataType() === 'Privatkunde')) {
                <span data-test="products-summary-customer-birthdate"> <br />{{ birthDate }}</span>
              }

              @if (telefonNumber) {
                <br />
              }
              @if (telefonNumber) {
                <span data-test="products-summary-customer-phonenumber">
                  {{ telefonNumber }}
                </span>
              }
              <br />
              <span data-test="products-summary-customer-email">
                {{ email }}
              </span>
              <ng-content select="[slot='products-summary-customerData-name-additionalContent']" />
            </p>
          </li>
          @if (idCard && idCard.art === 'Ausweis') {
            <li data-test="products-summary-customerData-idCard">
              <p class="text--big mb-0">
                <strong><span translate="summary.idData"></span></strong>
                <br />
                {{ idCard.type }}, {{ idCard.number }}, {{ idCard.issuer }}
              </p>
            </li>
          }
        </ul>
      </div>
    </div>
  </mwe-basic-card>
</div>
